module.exports = __webpack_public_path__ + "img/22.c5e040d0.jpg";